var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: {
            "margin-bottom": "10px",
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", gap: "10px" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { placeholder: "分类名称", clearable: "" },
                model: {
                  value: _vm.selectDataQuery.keywords,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectDataQuery, "keywords", $$v)
                  },
                  expression: "selectDataQuery.keywords",
                },
              }),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: {
                    placeholder: "菜品分组映射",
                    clearable: "",
                    filterable: "",
                  },
                  on: { change: _vm.handleMappingFilterChange },
                  model: {
                    value: _vm.mappingFilter,
                    callback: function ($$v) {
                      _vm.mappingFilter = $$v
                    },
                    expression: "mappingFilter",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "未分配映射", value: "unmapped" },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.menuInfos, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: "mapped_" + item.id },
                    })
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleFilter },
                },
                [_vm._v("\n        搜索\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.parentCategory && _vm.parentCategory.id
            ? _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.openCreateDialog },
                    },
                    [_vm._v("\n        创建二级分类\n      ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.showParentAlert && _vm.selectEntity && _vm.selectEntity.categoryName
        ? _c("el-alert", {
            staticStyle: { "margin-bottom": "12px" },
            attrs: {
              title: "上级分类：" + _vm.selectEntity.categoryName,
              type: "warning",
              "show-icon": "",
              closable: true,
            },
            on: { close: _vm.clearParent },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            "max-height": _vm.maxHeight,
            data: _vm.selectDataList,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              type: "index",
              align: "center",
              width: "50",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "ID", prop: "id", align: "center", width: "100" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "分类名称",
              prop: "categoryName",
              align: "center",
              "min-width": "120",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "分类编码",
              prop: "categoryCode",
              align: "center",
              "min-width": "120",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "一级分类名称",
              prop: "parentCategoryName",
              align: "center",
              "min-width": "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [_vm._v(_vm._s(row.parentCategoryName || "-"))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "关联菜品分组",
              prop: "menuInfoName",
              align: "center",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(row.menuInfoName || "-"))])]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "相关菜品", align: "center", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          icon: "el-icon-view",
                          type: "warning",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openGoodsVisible(row, 2)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          查看(" +
                            _vm._s(row.goodsCount) +
                            ")\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tableFrom.Operation"),
              align: "center",
              width: "250",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              icon: "el-icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openEditDialog(row.id)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectDataTotal > 0
        ? _c("sw-page", {
            attrs: {
              listQuery: _vm.selectDataQuery,
              total: _vm.selectDataTotal,
              pos: "btmRight",
            },
            on: { retPage: _vm.retPage },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.editForm.id ? "编辑分类" : "新增分类",
            visible: _vm.editVisible,
            size: "700px",
            direction: "rtl",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editFormRef",
              staticClass: "dialog-form",
              attrs: {
                model: _vm.editForm,
                "label-width": "120px",
                rules: _vm.editRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "分组名称", prop: "categoryName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { autosize: "" },
                    model: {
                      value: _vm.editForm.categoryName,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "categoryName", $$v)
                      },
                      expression: "editForm.categoryName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "分类编码", prop: "categoryCode" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { autosize: "" },
                    model: {
                      value: _vm.editForm.categoryCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "categoryCode", $$v)
                      },
                      expression: "editForm.categoryCode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "分类简介", prop: "categoryDesc" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      autosize: { minRows: 4, maxRow: 6 },
                      type: "textarea",
                    },
                    model: {
                      value: _vm.editForm.categoryDesc,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "categoryDesc", $$v)
                      },
                      expression: "editForm.categoryDesc",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "关联菜单分组", prop: "menuInfoId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "400px" },
                      attrs: { placeholder: "关联菜单分组" },
                      model: {
                        value: _vm.editForm.menuInfoId,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "menuInfoId", $$v)
                        },
                        expression: "editForm.menuInfoId",
                      },
                    },
                    _vm._l(_vm.menuInfos, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.id, label: item.codeName },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveEntity } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.selectEntity.categoryName,
            visible: _vm.goodsVisible,
            width: "1000px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.goodsVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "filter-container",
              staticStyle: { "margin-bottom": "10px" },
            },
            [
              _c("el-input", {
                staticClass: "filter-item",
                staticStyle: { width: "200px" },
                attrs: { placeholder: "商品名称", clearable: "" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.getGoodsList($event)
                  },
                },
                model: {
                  value: _vm.goodsQuery.keywords,
                  callback: function ($$v) {
                    _vm.$set(_vm.goodsQuery, "keywords", $$v)
                  },
                  expression: "goodsQuery.keywords",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "filter-item",
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.getGoodsList },
                },
                [_vm._v("\n        搜索\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                "max-height": _vm.maxHeight,
                data: _vm.goodsList,
                stripe: "",
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  prop: "id",
                  align: "center",
                  width: "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "商品名称",
                  prop: "goodsName",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "商品编码",
                  prop: "goodsCode",
                  align: "center",
                  "min-width": "120",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { padding: "16px 24px 32px 24px" } },
            [
              _vm.goodsTotal > 0
                ? _c("sw-page", {
                    attrs: {
                      listQuery: _vm.goodsQuery,
                      total: _vm.goodsTotal,
                      pos: "btmRight",
                    },
                    on: { retPage: _vm.getGoodsList },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }